import { missingWidget } from '../utils/helpers';

export default function photoGallery() {
  const widgetName = 'photoGallery';
  const widgetOpts = typeof photoGalleryOpts === 'undefined' ? null : photoGalleryOpts;

  const $widget = $(`#${widgetName}`);

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  const linkedImages = true;

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    textOverImage: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
        changeFormatCards(data.items);
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      } else {
        $card.addClass('linked-images');
        $card.append('<div class="overlay" aria-hidden="true"></div>');
      }
    });
  }
}
